import { formatPhoneNumber } from 'react-phone-number-input'

/**
 * Safely formats a phone number for display, handling cases where
 * the number may not have a country code prefix.
 *
 * @param {string} phoneNumber - The phone number to format
 * @param {string} defaultCountryCode - The default country code to use (default: '+1' for US)
 * @returns {string} - The formatted phone number or the original if formatting fails
 */
export default function formatPhoneNumberSafe(
  phoneNumber,
  defaultCountryCode = '+1',
) {
  if (!phoneNumber || typeof phoneNumber !== 'string') {
    return ''
  }

  const trimmedNumber = phoneNumber.trim()

  if (!trimmedNumber) {
    return ''
  }

  if (trimmedNumber.startsWith('+')) {
    const formatted = formatPhoneNumber(trimmedNumber)
    return formatted || trimmedNumber
  }

  const numberWithCountryCode = `${defaultCountryCode}${trimmedNumber}`
  const formatted = formatPhoneNumber(numberWithCountryCode)

  return formatted || trimmedNumber
}
